import AdminLayout from "./AdminLayout";

const SettingInner = () => {
    return (
        <div>
            <AdminLayout>
                <div className="setting_wepper">

                </div>
            </AdminLayout>
        </div>
    )
}

export default SettingInner;